import { FC, useMemo } from 'react';

import { ToucanComponents } from '@jointoucan/toucan-design';

import { trackEvent } from '~/helpers/analytics';

import { useDoctorContext } from './DoctorContext';

const { Button } = ToucanComponents;

export const Download: FC = () => {
  const { rows } = useDoctorContext();
  const dataUri = useMemo(() => {
    return `data:text/csv;charset=utf-8,${encodeURIComponent(
      ['Label, Value', ...rows.map((row) => `${row.label}, ${row.value.replace(',', '')}`)].join('\n'),
    )}`;
  }, [rows]);
  const userId = rows.find(({ label }) => label === 'User Id')?.value ?? 'anon';
  return (
    <Button download={`diagnosis-${userId}.csv`} href={dataUri} onClick={() => trackEvent({ name: 'Doctor download' })}>
      Download CSV
    </Button>
  );
};
